import type { MetricItemDTO } from '@/types/agentEvents';

export function parseHHMMSSToSeconds(value: number | string): number {
  if (typeof value === 'number') return value;
  const s = String(value);
  const match = s.match(/^(\d+):(\d+):(\d+)$/);
  if (!match) return 0;
  const hours = parseInt(match[1], 10);
  const minutes = parseInt(match[2], 10);
  const seconds = parseInt(match[3], 10);
  return hours * 3600 + minutes * 60 + seconds;
}

export function formatSecondsToHHMMSS(totalSeconds: number): string {
  const safe = Number.isFinite(totalSeconds)
    ? Math.max(0, Math.floor(totalSeconds))
    : 0;
  const hours = Math.floor(safe / 3600);
  const minutes = Math.floor((safe % 3600) / 60);
  const seconds = safe % 60;
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(
    seconds
  ).padStart(2, '0')}`;
}

export function parsePercentToNumber(value: number | string): number {
  if (typeof value === 'number') return value;
  const n = parseFloat(String(value).replace(/%/g, ''));
  return Number.isFinite(n) ? n : 0;
}

export function meanMetricValue(
  items: MetricItemDTO[],
  toNumber: (v: number | string) => number
): number {
  if (!items.length) return 0;
  const numbers = items
    .map(i => toNumber(i.value))
    .filter(n => Number.isFinite(n));
  if (!numbers.length) return 0;
  const sum = numbers.reduce((a, b) => a + b, 0);
  return sum / numbers.length;
}

export function sumMetricValue(
  items: MetricItemDTO[],
  toNumber: (v: number | string) => number
): number {
  if (!items.length) return 0;
  return items
    .map(i => toNumber(i.value))
    .filter(n => Number.isFinite(n))
    .reduce((a, b) => a + b, 0);
}

export function formatPercentage(value: number, decimals = 2): string {
  if (!Number.isFinite(value)) return '0.00';
  return value.toFixed(decimals);
}
